"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MaterialsController = function MaterialsController() {
  (0, _classCallCheck3.default)(this, MaterialsController);
};

// WEBPACK FOOTER //


exports.default = MaterialsController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-spec/controller.js
 **/